module.exports = __webpack_public_path__ + "media/images/pack-03-caac292b5ebe146721a174c11f121309.jpg";